import {LevelTwo} from "./LevelTwo";
import {Special} from "./Special";
import {SegmentBodySale} from "./SegmentBodySale";
import {mapState, mapWritableState} from 'ui.vue3.pinia'
import {menuStore} from './store'

export const UnitBody = {
    props: {
        ar1Item: Object
    },
    components: {
        LevelTwo,
        Special,
        SegmentBodySale,
    },
    computed: {
        ...mapState(menuStore, ['sales', 'isMobile', 'menu_utp']),
        ...mapWritableState(menuStore, ['parent']),
        // TODO: почти дублирует items из store только по children
        levelOneItems() {
            let result = [];
            if (this.isMobile) {
                const isHasSelected = this.ar1Item.children.findIndex(el => el.isShow === true) >= 0

                if (isHasSelected) {
                    result = this.ar1Item.children.filter(el => el.isShow === true)
                } else {
                    result = this.ar1Item.children;
                }
            } else {
                result = this.ar1Item.children;
            }
            return result;
        },

        levelTwoItems() {
            return this.levelOneItems.filter(item => item.type === 'main');
        },
        levelTwoItemsCol4() {
            return this.levelOneItems.find(item => item.type === 'col4');
        },
        levelTwoItemsSale() {
            return this.levelOneItems.find(item => item.type === 'sale');
        },
        imgBanner() {
            let src = this.ar1Item['banners']['display_img']
            return `background-image:url(${src})`
        },
        isShowCol5() {
            let result = true
            if(this.ar1Item.col5) {
                result = Boolean(this.ar1Item.col5.find(el => el.isShow === true))
            }
            return result
        },
        isShowLinkSectionAll() {
            // TODO: придумать как упростить
            let result = false
            if(this.isShowCol5) {
                result = true
            }
            if(Boolean(this.levelTwoItemsSale)) {
                result = false
            }
            if(Boolean(this.parent)){
                result = false
            }
            return result
        },

    },
    methods: {
        openLevelTwo() {
            this.ar1Item.children.forEach((item) => {
                item.isShow = false
            })
            this.parent = this.ar1Item
            if(this.ar1Item.col5) {
                this.ar1Item.col5.forEach(item => item.isShow = false)
            }
        },
    },
    // language=Vue
    template: `
        <div class="header-nav-main-unit-body">
            <div class="container">
              <div class="header-nav-main-unit-body-section header-nav-main-unit-body-section_wide header-nav-main-unit-body-section_white">
                <div class="header-nav-main-unit-body-section-top">
                    <SegmentBodySale v-if="ar1Item.sale && levelTwoItemsSale" 
                        :itemSale="levelTwoItemsSale"
                        :ar1Item="ar1Item" 
                        @open="openLevelTwo">
                    </SegmentBodySale>
                    <div v-if="isShowLinkSectionAll && ar1Item['show_all_position_top']" class="header-nav-main-unit-body-section-segment header-nav-main-unit-body-section-segment_adaptive-only">
                        <a class="header-nav-main-unit-body-section-segment-all" :href="ar1Item['href']">
                            Посмотреть все 
                        </a>
                    </div>
                    <LevelTwo v-for="(ar2Item, key) in levelTwoItems"
                        :ar2Item = "ar2Item"                        
                        :key="key"
                        @open="openLevelTwo"                         
                    >
                    </LevelTwo>
                  <a class="header-nav-main-unit-body-section-all" :href="ar1Item['href']">Посмотреть все</a>
                </div>
    
                <div class="header-nav-main-unit-body-section-bottom">
                  <a class="header-nav-main-unit-body-section-banner header-nav-main-unit-body-section-banner_bigtext header-nav-main-unit-body-section-banner_wide" 
                     :href="ar1Item['banners']['property_link_1_value']" 
                     :style="imgBanner">
                  </a>
                </div>
              </div>
              <div class="header-nav-main-unit-body-section header-nav-main-unit-body-section_narrow">
                <Special v-if="ar1Item['sale']" :ar1Item="ar1Item"></Special>
                <div v-else class="header-nav-main-unit-body-section-top">
                    <LevelTwo v-if="levelTwoItemsCol4" :ar2Item="levelTwoItemsCol4" :key="4" @open="openLevelTwo"></LevelTwo>
                    <div v-if="isShowLinkSectionAll && !ar1Item['show_all_position_top']" class="header-nav-main-unit-body-section-segment header-nav-main-unit-body-section-segment_adaptive-only">
                        <a class="header-nav-main-unit-body-section-segment-all" :href="ar1Item['href']">
                            Посмотреть все 
                        </a>
                    </div> 
                    <div v-if="isShowCol5" class="header-nav-main-unit-body-section-segment header-nav-main-unit-body-section-segment_list">
                        <div class="header-nav-main-unit-body-section-segment-body">
                            <a v-for="(ar3Item, key) in ar1Item.col5" 
                                class="header-nav-main-unit-body-section-segment-body-unit header-nav-main-unit-body-section-segment-body-unit_big"
                                :class="ar3Item['class']"
                                :href="ar3Item['href']"
                                v-html="ar3Item['text']">
                           </a>
                        </div>
                    </div>
                </div>
              
                <div v-if="ar1Item['banners']" class="header-nav-main-unit-body-section-bottom">
                    <a class="header-nav-main-unit-body-section-banner header-nav-main-unit-body-section-banner_small header-nav-main-unit-body-section-banner_80"
                       :href="ar1Item['banners']['property_link_2_value']"
                       style="background-color:#ff5010">
                        <div class="header-nav-main-unit-body-section-banner-title" v-html="ar1Item['banners']['property_title_2_value']"></div>
                        <div class="header-nav-main-unit-body-section-banner-additional header-nav-main-unit-body-section-banner-additional_zigzag"></div>
                        <div class="header-nav-main-unit-body-section-banner-additional header-nav-main-unit-body-section-banner-additional_circle"></div>
                        <div class="header-nav-main-unit-body-section-banner-additional header-nav-main-unit-body-section-banner-additional_under">
                            до
                        </div>
                        <div class="header-nav-main-unit-body-section-banner-additional header-nav-main-unit-body-section-banner-additional_number">{{ar1Item['banners']['property_percent_value']}}</div>
                        <div class="header-nav-main-unit-body-section-banner-additional header-nav-main-unit-body-section-banner-additional_percent">
                            %
                        </div>
                    </a>
                </div>
            </div>
            </div>
            <div v-html="menu_utp"></div>
        </div>
    `
}